import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import RenderTextField from 'sama_global/components/RenderInput/RenderTextField';

const useStyles = makeStyles(() => ({
  fit: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,

    '& div label div': {
      whiteSpace: 'nowrap',
    },
    '& > div': {
      minWidth: '158px',
      width: '33%',
      '@media(max-width: 680px)': {
        width: '50%',
      },
      '@media(max-width: 450px)': {
        width: '100%',
      },
    },
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,

    '& h3': {
      textAlign: 'center',
    },
  },
  btn: {
    marginTop: 20,
  },
}));

const ProfileForm = ({ title, fields, handleSubmit, fit, buttonText }) => {
  const classes = useStyles();

  return (
    <form
      name={`form-${Math.random()}`}
      className={classes[fit ? 'fit' : 'root']}
      onSubmit={handleSubmit}
    >
      <h3>
        <FormattedMessage id={title} defaultMessage={title} />
      </h3>
      {fields.map(item => (
        <Fragment key={item.name}>
          <Field
            name={item.name}
            component={item.component || RenderTextField}
            validate={item.validate}
            label={
              <FormattedMessage id={item.locale} defaultMessage={item.locale} />
            }
            options={item.options}
            variant="outlined"
            disabled={item.disabled}
          />
          {item.info && <FormattedMessage id={item.info} />}
        </Fragment>
      ))}
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.btn}
      >
        <FormattedMessage id={buttonText} defaultMessage="" />
      </Button>
    </form>
  );
};

ProfileForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  fit: PropTypes.bool,
};

ProfileForm.defaultProps = {
  title: ' ',
  fit: false,
  buttonText: 'SAVE',
};

export default reduxForm({
  // form: 'mainform',
})(ProfileForm);
